import { render } from "./notFoundPage.vue?vue&type=template&id=409412e0&scoped=true"
const script = {}

import "./notFoundPage.vue?vue&type=style&index=0&id=409412e0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409412e0"]])

export default __exports__